// extracted by mini-css-extract-plugin
module.exports = {"placeIconColumn":"PlaceItem_placeIconColumn_NZM0y","placeLine":"PlaceItem_placeLine_1m6dB"};